import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-footer-comingsoon',
  templateUrl: './footer-comingsoon.component.html',
  styleUrls: ['./footer-comingsoon.component.scss']
})
export class FooterComingsoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
